/**
 * Usage analytics — sign-in tracking + device breakdown for the Insights page.
 */
import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
export const DeviceTypeSchema = z.enum(['mobile', 'tablet', 'desktop']);
export const DisplayModeSchema = z.enum(['browser', 'standalone']);
/** Client → server on app load. Device type / OS / browser are parsed from the
 *  User-Agent server-side; the client only contributes what UA can't tell us. */
export const SessionPingSchema = z.object({
    /** matchMedia('(display-mode: standalone)') — installed PWA vs browser tab. */
    standalone: z.boolean().optional(),
    timezone: z.string().max(60).optional().nullable(),
});
export const SessionPingResponseSchema = z.object({ ok: z.boolean() });
const CountRowSchema = z.object({ key: z.string(), count: z.number().int() });
export const UsageUserRowSchema = z.object({
    user_id: UuidSchema,
    display_name: z.string(),
    role: z.string(),
    last_sign_in_at: IsoDateTimeSchema.nullable(),
    last_seen_at: IsoDateTimeSchema.nullable(),
    sign_in_count: z.number().int(),
    /** Most-recent device, e.g. "iOS · Safari" or "Windows · Chrome". */
    last_device: z.string().nullable(),
    last_device_type: DeviceTypeSchema.nullable(),
});
export const UsageResponseSchema = z.object({
    /** Distinct users seen in the last 7 / 30 days (relative to now). */
    active_7d: z.number().int(),
    active_30d: z.number().int(),
    total_users: z.number().int(),
    /** Sessions started within the selected [from, to] range. */
    sign_ins_in_range: z.number().int(),
    sessions_today: z.number().int(),
    by_device: z.array(CountRowSchema),
    by_platform: z.array(CountRowSchema),
    by_os: z.array(CountRowSchema),
    /** Sign-ins per day in range — { day: yyyy-MM-dd, count }. */
    sign_ins_by_day: z.array(z.object({ day: z.string(), count: z.number().int() })),
    /** One row per user (incl. never-signed-in), newest activity first. */
    users: z.array(UsageUserRowSchema),
});
//# sourceMappingURL=usage.js.map